import { BaseResponse } from '../../../../../types/api/api.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { UpdatePasswordQueryParams } from './NewPasswordForm.types';

const PREFIX = '[updatePasswordQuery]';

export const UPDATE_PASSWORD_QUERY_KEY = 'UPDATE_PASSWORD';

export const updatePasswordQuery = async (params: UpdatePasswordQueryParams) => {
  console.log(PREFIX, `Requesting user account creation...`);
  const response = await AUTH_ENDPOINTS.updatePassword(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as BaseResponse;
};
